var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-button",class:{
	underline: _vm.underline,
	small: _vm.size == 'small',
},style:(Object.assign({}, _vm.styles)),on:{"click":_vm.clickHandler}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }